// NavisionStockStatus.tsx
import React from 'react';
import StockStatus from '../StockStatus/StockStatus';
import { formatIncomingStocksString } from '../NavisionStock/services/NavisionStockService';
import { ProductStocks } from '../NavisionStock/types/ProductStocks';

interface NavisionStockStatusProps {
  navisionStock?: ProductStocks;
}

const NavisionStockStatus: React.FC<NavisionStockStatusProps> = ({ navisionStock }) => {
  if (!navisionStock || !navisionStock.stockStatuses) {
    return null;
  }

  return (
    <>
      {/* Render the first stock status */}
      {navisionStock.stockStatuses[0] && (
        <StockStatus {...navisionStock.stockStatuses[0].stockStatus} />
      )}

      {/* Render the second stock status, if available */}
      {navisionStock.stockStatuses[1] && (
        <StockStatus {...navisionStock.stockStatuses[1].stockStatus} />
      )}

      {/* Render formatted expected arrival date */}
      {navisionStock.formattedExpectedArrivalDate && (
        <div className="flex-1 text-xs">
          {formatIncomingStocksString(
            navisionStock.totalIncomingQuantity,
            navisionStock.firstShipmentQuantity,
            navisionStock.formattedExpectedArrivalDate
          )}
        </div>
      )}
    </>
  );
};

export default NavisionStockStatus;